@use '@design/components/custom-scroll/custom-scroll' as *;

$alfred-footer-spacer-height: 188px;

.root {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 0;
  overflow-x: auto;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  @include custom-scroll-minimal;
}

.contentWithFixedFooter {
  padding-bottom: $alfred-footer-spacer-height;
}

.root:has([data-thinking-feedback-visible]) .contentWithFixedFooter {
  padding-bottom: $alfred-footer-spacer-height + 128px;
}
